import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { userDate } from 'owa-datetime';
import MeetingResponseMessage from 'owa-service/lib/contract/MeetingResponseMessageType';

export default function generatePartialEventForProposeNewTime(
    item: MeetingResponseMessage
): Partial<CalendarEvent> {
    const proposedStartInOwaDate = userDate(item.ProposedStart);
    const proposedEndInOwaDate = userDate(item.ProposedEnd);

    let partialEvent: Partial<CalendarEvent> = {
        Start: proposedStartInOwaDate,
        End: proposedEndInOwaDate,
    };

    return partialEvent;
}
